import React  from 'react';
import Formulas from './Formulas'
import Back from './Back'

const Icons = {
    formulas: <Formulas />,
    back: <Back />
}
export default Icons;